import { Container } from '@mui/material';
import Link from '@tcs/create-account/components/Link';
import useConfig from '@tcs/create-account/hooks/useConfig';
import {
  HeaderType,
  ImageType,
  LinkType,
} from '@tcs/create-account/utils/prismic/types';
import { INDEX_URL } from '@tcs/create-account/utils/routes';
import cs from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CustomNotificationBanner } from './Banners';
import { useStyles } from './style';

interface HeaderProps {
  data: HeaderType;
}

const Header = ({ data }: HeaderProps) => {
  const config = useConfig();
  const classes = useStyles();
  const { showImageVersion, customNotification } = useFlags();

  if (!data) return null;
  if (!config) return null;

  const { extra_logo_link, extra_logo, body } = data;

  const getLogo = (logo: ImageType, link: LinkType) => (
    <a href={link.url} className={classes.logoLink}>
      <img
        className={classes.logo}
        src={logo.url}
        alt={logo.alt}
        width={logo.dimensions.width}
        height={logo.dimensions.height}
      />
    </a>
  );

  // TODO: provide panel support for items in slice
  const topLinkGroup = (
    <div className={classes.topLine}>
      {body.map(({ primary }) => (
        <Link
          link={primary.link}
          className={classes.topLink}
          key={primary.name}>
          {primary.name}
        </Link>
      ))}
    </div>
  );

  return (
    <>
      {showImageVersion && (
        <div className={classes.versionTag}>{config.IMAGE_VERSION}</div>
      )}
      <header className={classes.header}>
        <Container disableGutters className={classes.container}>
          {topLinkGroup}
          <div className={classes.mainLine}>
            <div className={classes.logos}>
              <a href={INDEX_URL} className={classes.logoLink}>
                <img
                  className={cs(classes.logo, classes.mainLogo)}
                  src={`${config.REACT_APP_BASE_PATH}/img/forge_trust_logo.svg`}
                  alt="logo"
                />
              </a>
              {extra_logo?.url && getLogo(extra_logo, extra_logo_link)}
            </div>
          </div>
        </Container>
        {customNotification && (
          <CustomNotificationBanner text={customNotification} />
        )}
      </header>
      <div className={classes.headerGap} />
      {customNotification && <div className={classes.bannerGap} />}
    </>
  );
};

export default Header;
